import { supabase } from "../supabase";

const BASE_URL = process.env.REACT_APP_API_URL;

// ── Generic helpers ───────────────────────────────────────────────────────────
async function request(path, options = {}) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  const res = await fetch(`${BASE_URL}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...options,
  });
  if (!res.ok) {
    const msg = await res.text();
    throw new Error(msg || `Request failed: ${res.status}`);
  }
  if (res.status === 204) return null;
  return res.json();
}

// ── Players ───────────────────────────────────────────────────────────────────
export const playersApi = {
  getAll: () => request("/player"),
  getById: (id) => request(`/player/${id}`),
  create: (player) =>
    request("/player", { method: "POST", body: JSON.stringify(player) }),
  update: (id, player) =>
    request(`/player/${id}`, { method: "PUT", body: JSON.stringify(player) }),
  delete: (id) => request(`/player/${id}`, { method: "DELETE" }),
};

// ── Tournaments ───────────────────────────────────────────────────────────────
export const tournamentsApi = {
  getAll: () => request("/tournament"),
  getById: (id) => request(`/tournament/${id}`),
  create: (tournament) =>
    request("/tournament", {
      method: "POST",
      body: JSON.stringify(tournament),
    }),
  update: (id, tournament) =>
    request(`/tournament/${id}`, {
      method: "PUT",
      body: JSON.stringify(tournament),
    }),
  delete: (id) => request(`/tournament/${id}`, { method: "DELETE" }),
};

// ── Match Results ─────────────────────────────────────────────────────────────
export const matchResultsApi = {
  create: (result) =>
    request("/matchresult", { method: "POST", body: JSON.stringify(result) }),
  getAll: () => request("/matchresult/all"),
  getByPlayer: (playerName) =>
    request(`/matchresult/player/${encodeURIComponent(playerName)}`),
  getByTournament: (tournamentId) =>
    request(`/matchresult/tournament/${tournamentId}`),
  deleteAll: () => request("/matchresult/all", { method: "DELETE" }),
};
